<template>
  <div>
    <b-card>
      <div
        class="table-header-border-bottom pb-1 mb-md-3 d-flex justify-content-between align-items-center"
      >
        <h3 class="mt-1 d-flex align-items-center">
          <feather-icon
            icon="CheckSquareIcon"
            class="mr-50"
            style="width: 18px; height: 18px"
          />
          <span>Transactions</span>
        </h3>
      </div>
      <b-form
        @submit.prevent="filter"
        class="filters rounded p-1 my-md-1 d-flex align-items-center justify-content-between flex-wrap"
      >
        <div class="col-sm-3 col-12 p-50 d-flex align-items-center">
          <!-- <div class="mr-50">
            <b-form-checkbox v-model="selectAll"></b-form-checkbox>
          </div> -->
          <v-select
            :options="types"
            v-model="type"
            label="label"
            :reduce="(option) => option.value"
            :searchable="false"
            placeholder="Display on the page"
            class="w-100"
          ></v-select>
        </div>

        <div class="col-sm-6 col-12 d-flex align-items-center flex-wrap p-50">
          <template v-if="type == 'payable'">
            <div class="col-md-6 col-12 py-50 px-sm-50 px-0">
              <select-box
                v-model="payable_type"
                class="w-100"
                searchable
                :lists="['user', 'partner', 'competition', 'plan']"
              />
            </div>
            <div class="col-md-6 col-12 py-50 px-sm-50 px-0">
              <select-box
                v-model="payable_id"
                label="text"
                class="w-100"
                select="id"
                searchable
                :url="payable_type"
              />
            </div>
          </template>
          
          <b-form-input
            v-else
            placeholder="search"
            v-model.trim="search"
            :disabled="!type"
          />
        </div>
        <div class="col-sm-3 col-12 p-50">
          <b-button
            class="w-100"
            type="submit"
            :disabled="!search && !(!search && payable_type && payable_id)"
          >
            <span class="text-muted h5"> Filtering</span>
          </b-button>
        </div>
      </b-form>
      <data-table :fields="fields" :items="transactions" :loading="loading">
        <template #id="{ data }">
          <div class="d-flex">
            <div class="pr-50 border-right mr-75">
              <span class="font-weight-bold h5 mb-0">{{ data.item.id }}</span>
            </div>
          </div>
        </template>
        <template #uuid="{ data }">
          <div
            class="d-flex align-items-center"
            v-b-tooltip.hover="data.item.uuid"
          >
            <div class="text-truncate" style="max-width: 250px">
              {{ data.item.uuid }}
            </div>
            <div>
              <feather-icon
                icon="CopyIcon"
                width="40px"
                class="ml-sm-75 cursor-pointer"
                @click="doCopy(data.item.uuid)"
              />
            </div>
          </div>
        </template>
        <template #type="{ data }">
          <b-badge
            class="p-75"
            :variant="data.item.type == 'withdraw' ? 'danger' : 'success'"
          >
            {{ data.item.type }}
          </b-badge>
        </template>
        <template #gateway="{ data }">
          <span
            v-if="hasOwnNestedProperty(data.item, 'meta.data.type')"
            v-b-tooltip.hover.v-primary="data.item.meta.data.id"
          >
            {{ data.item.meta.data.type }}
          </span>
          <span v-else>-</span>
        </template>
        <template #message="{ data }">
          <span class="nowrap-white-space">
            <span v-if="hasOwnNestedProperty(data.item, 'meta.message')">
              {{ data.item.meta.message }}
            </span>
            <span
              v-else-if="hasOwnNestedProperty(data.item, 'meta.data.message')"
            >
              {{ data.item.meta.data.message }}
            </span>
            <span v-else>-</span>
          </span>
        </template>
        <template #amount="{ data }">
          <span class="mb-0 text-green nowrap-white-space">
            {{
              data.item.amount_float
                ? `${
                    0 > data.item.amount_float
                      ? Math.abs(data.item.amount_float).toFixed(2)
                      : data.item.amount_float
                  } $`
                : "-"
            }}
          </span>
        </template>
        <template #payable="{ data }">
          <span style="white-space: nowrap">
            {{
              data.item.payable
                ? data.item.payable.name
                  ? data.item.payable.name
                  : data.item.payable.first_name +
                    " " +
                    data.item.payable.last_name
                : "-"
            }}
          </span>
        </template>

        <template #created_at="{ data }">
          <span class="nowrap-white-space">
            {{ toLocal(data.item.created_at) }}
          </span>
        </template>
      </data-table>

      <div
        class="w-100 d-flex flex-wrap align-items-center justify-content-between"
      >
        <b-pagination
          v-model="currentPage"
          :total-rows="pagination.total"
          :per-page="pagination.per_page"
          size="lg"
          pills
          class="my-2 d-flex justify-content-center"
        >
        </b-pagination>
      </div>
    </b-card>
  </div>
</template>
<script>
import {
  BButton,
  BModal,
  VBModal,
  BPagination,
  BLink,
  BCard,
  BFormCheckbox,
  BForm,
  BFormInput,
  BBadge,
  VBTooltip,
} from "bootstrap-vue";
import DataTable from "@/@core/components/data-table/DataTable.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import qs from "qs";
import VSelect from "vue-select";
import SelectBox from "@core/components/select-box/SelectBox.vue";
export default {
  components: {
    DataTable,
    BButton,
    BModal,
    BCard,
    VBModal,
    BPagination,
    BLink,
    BFormCheckbox,
    BForm,
    BFormInput,
    BBadge,
    VSelect,
    SelectBox,
  },
  data() {
    return {
      url: "/panel/financial/transactions",
      currentPage: 1,
      loading: false,
      pagination: {},
      pages: [],
      selectedPage: "",
      types: [
        { label: "Id", value: "uuid" },
        // { label: "Amount", value: "amount" },       * ERR 500
        { label: "Type", value: "type" },
        // { label: "Payable", value: "payable" },       * ERR 400
      ],
      type: "",
      search: "",
      payable_type: "",
      payable_id: "",
      fields: [
        { key: "id", label: "row" },
        { key: "uuid", label: "id" },
        { key: "payable", label: "wallet" },
        { key: "type", label: "type" },
        { key: "gateway", label: "gateway" },
        { key: "message", label: "message" },
        { key: "amount", label: "amount" },
        { key: "created_at", label: "created at" },
      ],
      transactions: [],
    };
  },
  directives: {
    "b-modal": VBModal,
    "b-tooltip": VBTooltip,
  },
  watch: {
    async type(val) {
      this.search = await "";
      if (this.$route.fullPath != "/financial/transactions") {
        this.$router.push({
          name: "financial-transactions",
        });
      }
    },
    currentPage(val) {
      if (val != this.$route.query.page) {
        this.$router.push({
          name: "financial-transactions",
          query: {
            ...this.$route.query,
            page: val,
          },
        });
      }
    },
    $route: {
      handler(val) {
        this.getTransactions();
      },
      immediate: true,
      deep: true,
    },
    search(val) {
      if (!val) {
        if (this.$route.query.filter) {
          let filter = {};
          this.$router.push({
            name: "financial-transactions",
            query: {
              filter,
            },
          });
        }
      }
    },
  },
  created() {
    if (this.$route.query.filter) {
      this.$router.push({
        name: "financial-transactions",
        query: {},
      });
    }
  },
  methods: {
    filter() {
      if (this.type) {
        let filter = {};
        if (this.type == "payable") {
          filter["payable_type"] = this.payable_type;
          filter["payable_id"] = this.payable_id;
        } else {
          filter[this.type] = this.search;
        }
        if (this.type == "uuid") {
          if (this.validatorUuid(this.search)) {
            this.$router
              .push({
                name: "financial-transactions",
                query: {
                  ...this.$route.query,
                  filter,
                },
              })
              .catch((err) => {});
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "The id is invalid!",
                icon: "CoffeeIcon",
                variant: "warning",
              },
            });
          }
        } else {
          this.$router.push({
            name: "financial-transactions",
            query: {
              ...this.$route.query,
              filter,
            },
          });
        }
      } else if (this.$route.fullPath != "/financial/transactions") {
        this.$router.push({
          name: "financial-transactions",
        });
      }
    },
    doCopy(id) {
      this.$copyText(id).then(
        () => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Text copied",
              icon: "BellIcon",
            },
          });
        },
        (e) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Can not copy!",
              icon: "BellIcon",
            },
          });
        }
      );
    },
    async getTransactions() {
      this.loading = true;
      try {
        const params = {
          per_page: 8,
          ...this.$route.query,
        };
        const { data } = await this.$http.get(this.url, {
          params,
          paramsSerializer: (params) => {
            return qs.stringify(params);
          },
        });
        this.transactions = data.data;
        this.pagination = await data.meta.pagination;
        this.currentPage = await this.pagination.current_page;
      } catch (err) {}
      this.loading = false;
    },
  },
};
</script>
